module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.1525/img/business-types/food-beverage.png"